import React from "react";
import { Form, Row, Col } from "react-bootstrap";

import CheckboxChecked from "../assets/icons/check_ic.png";

const Checkbox = ({ checked, label, className, renderLabel, onClick }) => {
  return (
    <div className={`d-flex align-items-start ${className}`}>
      <div
        style={{
          backgroundColor: "#efeef1",
          height: 18,
          width: 18,
          border: "solid 1px #E5E5E5",
          borderRadius: 1,
          marginRight: 10,
        }}
      >
        <img
          src={CheckboxChecked}
          onClick={onClick}
          style={{ opacity: checked ? 1 : 0, verticalAlign: "unset" }}
        />
      </div>
      {renderLabel ? (
        renderLabel()
      ) : (
        <span className="cursor-pointer" onClick={onClick}>
          {label}
        </span>
      )}
    </div>
  );
};

const PhoneNumberInput = ({
  countryCode,
  value,
  isInvalid,
  onChangeCountryCode,
  onChangePhoneNumber,
  error,
}) => {
  return (
    <div>
      <Row>
        <Col sm="3">
          <Form.Control
            as="select"
            custom
            value={countryCode}
            onChange={(e) => onChangeCountryCode(e.target.value)}
          >
            <option>+1</option>
            <option>+91</option>
            <option>+222</option>
          </Form.Control>
        </Col>
        <Col sm="9">
          <Form.Control
            type="number"
            value={value}
            onChange={(e) => onChangePhoneNumber(e.target.value)}
            isInvalid={isInvalid}
          />
          <span className="text-danger">{error}</span>
        </Col>
      </Row>
    </div>
  );
};

export { Checkbox, PhoneNumberInput };
